import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { Router } from '@angular/router';
import { CorreosService } from './correos.service';
import swal from 'sweetalert'
import PouchDB from 'pouchdb';
import { ToastController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class SeedsService {
  public seeds
  constructor(private db:AngularFirestore,
    private router:Router,
    public toaster:ToastController,
    private correoService:CorreosService,
    private auth:AngularFireAuth) {
    this.seeds= new PouchDB('maxsellglobal_mobile')
   }

/**
 * It returns a promise that resolves to a Firestore QuerySnapshot
 * @returns A promise
 */
  devolverPuntosSemilla(){
    return this.db.collection('seeds').get()
   
   }
 
 
 /**
  * It returns a promise that resolves to a document snapshot of the seed with the given id
  * @param id - The id of the document to be deleted.
  * @returns A promise
  */
 
   devolverPuntoSemilla(id){
    return this.db.collection('seeds').doc(id).get()
   }


  /**
   * It returns the seeds of a provider
   * @param uid - The user's unique ID.
   * @returns A promise
   */
   devolverPuntosSemillaProveedores(uid){
     return this.db.collection('seeds',ref=>ref.where('uid_proveedor','==',uid)).get()
    
    }
 
 
 /**
  * It returns a promise that resolves to a snapshot of the document with the given uid
  * @param uid - The user's ID.
  * @returns the document of the user with the uid that is passed as a parameter.
  */
 
   devolverRuteros(uid){
     return this.db.collection('usuarios').doc(uid).get()
    
    }

  /**
   * The back() function navigates the user back to the home page
   */

    back(){
      this.router.navigate(['/'])
    }

  /**
   * It navigates to the create-points page.
   */

    goSeed(){
     this.router.navigate(['/crear-puntos'])
    }

 
    /**
     * This function is used to verify if the seeds are damaged, if they are damaged, the function will
     * send a notification to the user
     */
    verificarSemillasDanadas(){
     
        this.auth.auth.onAuthStateChanged(user=>{
          try{
            this.db.collection('seeds',ref=>ref.where('uid_proveedor','==',user.uid)).get().subscribe(res=>{
              res.docs.forEach(doc=>{
                if(doc.data()['full_stock']>5){
                  swal(`El punto ${doc.data()['nombreEstablecimiento']} que presenta muchos FullStock`,"Aviso, este negocio posiblemente no esta generando buenas ganacias","warning")
                }
              })
            })
          }catch(e){
            console.log('')
          }
         
        })
     

      
    }

  
   
    async registroPuntosBaseLocal(uid){
      
      try{
        const querySnapshot = this.db.collection('seeds',ref=>ref.where('uid_proveedor','==',uid)).get()
     
        querySnapshot.forEach(async doc => {
          if(doc.empty){
            this.seeds.put({
              _id:uid,
              base64:'',
              nombreEstablecimiento:'',
              tipoEstablecimiento:'',
              nit:'',
              nombreEncargado:'',
              correoElectronico:'',
              municipio:'',
              departamento:'',
              direccion:'',
              coords:'',
              fechaQuemada:'',
              pais:'',
              diaModifica:'',
              numlocal:'',
              fecha:'',
              numeroTelefonico:'',
              direccionEncargado:'',
              dia:'',
              estado:'',
              notaClave:'',
              modulos:'',
              uid_proveedor:'',
              configuracionModulos:'',
              precioVenta:0
            }).then(d=>{
              console.log(d)
            })
          }else{
            doc.forEach(i=>{
              this.seeds.put({
                _id: i.id,
                base64:i.data()['base64'],
                nombreEstablecimiento:i.data()['nombreEstablecimiento'],
                tipoEstablecimiento:i.data()['tipoEstablecimiento'],
                nit:i.data()['nit'],
                nombreEncargado:i.data()['nombreEncargado'],
                correoElectronico:i.data()['correoElectronico'],
                municipio:i.data()['municipio'],
                departamento:i.data()['departamento'],
                direccion:i.data()['direccion'],
                coords:i.data()['coords'],
                fechaQuemada:i.data()['fechaQuemada'],
                pais:i.data()['pais'],
                diaModifica:i.data()['diaModifica'],
                numlocal:i.data()['numlocal'],
                fecha:i.data()['fecha'],
                numeroTelefonico:i.data()['numeroTelefonico'],
                direccionEncargado:i.data()['direccionEncargado'],
                dia:i.data()['dia'],
                estado:i.data()['estado'],
                notaClave:i.data()['notaClave'],
                modulos:i.data()['modulos'],
                uid_proveedor:i.data()['uid_proveedor'],
                configuracionModulos:i.data()['configuracionModulos'],
                precioVenta:i.data()['precioVenta']
              }).then(d=>{
              })
            })
          }       
        });
      }catch(e){
        console.log('')
      }
      
      
    
    }
    async registroPuntoBaseLocal(doc,id){     
   
          await this.seeds.put({
            _id:id,
            base64:doc['base64'],
            nombreEstablecimiento:doc['nombreEstablecimiento'],
            tipoEstablecimiento:doc['tipoEstablecimiento'],
            nit:doc['nit'],
            nombreEncargado:doc['nombreEncargado'],
            correoElectronico:doc['correoElectronico'],
            municipio:doc['municipio'],
            departamento:doc['departamento'],
            direccion:doc['direccion'],
            coords:doc['coords'],
            fechaQuemada:doc['fechaQuemada'],
            pais:doc['pais'],
            diaModifica:doc['diaModifica'],
            numlocal:doc['numlocal'],
            fecha:doc['fecha'],
            numeroTelefonico:doc['numeroTelefonico'],
            direccionEncargado:doc['direccionEncargado'],
            dia:doc['dia'],
            estado:doc['estado'],
            notaClave:doc['notaClave'],
            modulos:doc['modulos'],
            uid_proveedor:doc['uid_proveedor'],
            configuracionModulos:doc['configuracionModulos'],
            precioVenta:doc['precioVenta']
          }).then(d=>{
            console.log(d)
          })  
    }
   

    async updatePuntoBaseLocal(doc,id){     
      await this.seeds.get(id).then((seed)=>{
        console.log(doc)
        console.log(id)
        seed.base64=doc['base64'],
        seed.nombreEstablecimiento=doc['nombreEstablecimiento'],
        seed.tipoEstablecimiento=doc['tipoEstablecimiento'],
        seed.nit=doc['nit'],
        seed.nombreEncargado=doc['nombreEncargado'],
        seed.correoElectronico=doc['correoElectronico'],
        seed.municipio=doc['municipio'],
        seed.departamento=doc['departamento'],
        seed.direccion=doc['direccion'],
        seed.coords=doc['coords'],
        seed.fechaQuemada=doc['fechaQuemada'],
        seed.pais=doc['pais'],
        seed.diaModifica=doc['diaModifica'],
        seed.numlocal=doc['numlocal'],
        seed.fecha=doc['fecha'],
        seed.numeroTelefonico=doc['numeroTelefonico'],
        seed.direccionEncargado=doc['direccionEncargado'],
        seed.dia=doc['dia'],
        seed.estado=doc['estado'],
        seed.notaClave=doc['notaClave'],
        seed.modulos=doc['modulos'],
        seed.uid_proveedor=doc['uid_proveedor'],
        seed.configuracionModulos=doc['configuracionModulos'],
        seed.precioVenta=doc['precioVenta']
        this.seeds.put(seed)
      })
        
    }
    async updatePuntoBaseQR(doc,id){     
      await this.seeds.get(id).then((seed)=>{
        console.log(doc)
        console.log(id)
        seed.base64=doc['base64'],
        seed.nombreEstablecimiento=doc['nombreEstablecimiento'],
        seed.tipoEstablecimiento=doc['tipoEstablecimiento'],
        seed.nit=doc['nit'],
        seed.nombreEncargado=doc['nombreEncargado'],
        seed.correoElectronico=doc['correoElectronico'],
        seed.municipio=doc['municipio'],
        seed.departamento=doc['departamento'],
        seed.direccion=doc['direccion'],
        seed.coords=doc['coords'],
        seed.fechaQuemada=doc['fechaQuemada'],
        seed.pais=doc['pais'],
        seed.diaModifica=doc['diaModifica'],
        seed.numlocal=doc['numlocal'],
        seed.fecha=doc['fecha'],
        seed.numeroTelefonico=doc['numeroTelefonico'],
        seed.direccionEncargado=doc['direccionEncargado'],
        seed.dia=doc['dia'],
        seed.estado=doc['estado'],
        seed.notaClave=doc['notaClave'],
        seed.modulos=doc['modulos'],
        seed.uid_proveedor=doc['uid_proveedor'],
        seed.configuracionModulos=doc['configuracionModulos'],
        seed.precioVenta=doc['precioVenta']
        seed.qrCode=doc['qrCode']
        this.seeds.put(seed).then((e)=>{
          console.log(e)
        })
      })
        
    }
    async eliminarPuntoBaseLocal(id){
      await this.seeds.get(id).then((doc)=> {
        this.seeds.remove(doc._id,doc._rev)
      }).then(function (result) {
        console.log(result)
      }).catch(function (err) {
        console.log(err);
      });
    }
   
    async actualizarEstadoRecaudoLocal(objSeed){
      await this.seeds.get(objSeed.id).then((doc)=>{     
        doc.estado=objSeed.estado,
        doc.diaModificante=objSeed.diaModificante,
        doc.fechaUltimaVisita=objSeed.fechaUltimaVisita,
        doc.full_stock=objSeed.full_stock
        doc.cerrado=objSeed.cerrado
        this.seeds.put(doc).then((resp)=>{
          console.log(resp)
        })
      })
    }

}
